import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface ProgressBarProps {
  value: number
  max?: number
  label: string
  showValue?: boolean
  tone?: 'brand' | 'success' | 'warning'
  className?: string
}

export function ProgressBar({
  value,
  max = 100,
  label,
  showValue = true,
  tone = 'brand',
  className,
}: ProgressBarProps) {
  const safeMax = Math.max(max, 1)
  const safeValue = Math.min(Math.max(value, 0), safeMax)
  const percentage = Math.round((safeValue / safeMax) * 100)

  return (
    <div className={mergeClassNames('ds-progress', className)}>
      <div className="ds-progress__header">
        <span>{label}</span>
        {showValue ? <strong className="numeric">{percentage} %</strong> : null}
      </div>
      <div
        className="ds-progress__track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-valuenow={safeValue}
      >
        <span
          className={mergeClassNames('ds-progress__value', `ds-progress__value--${tone}`)}
          style={{ width: `${String(percentage)}%` }}
        />
      </div>
    </div>
  )
}
